<div [className]="classCard">
  <ng-content [className]="classCard"></ng-content>
</div>
